import React, { FC } from 'react';

export const NationId: FC = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="nation"
    >
      <g clipPath="url(#clip0_141_423)">
        <path
          d="M4.72664 7.85094C6.34229 7.85103 7.65211 6.54135 7.65219 4.9257C7.65228 3.31005 6.3426 2.00024 4.72695 2.00016C3.1113 2.00007 1.80149 3.30974 1.8014 4.92539C1.80132 6.54104 3.11099 7.85086 4.72664 7.85094Z"
          fill="#F0F0F0"
        />
        <path
          d="M4.72695 2.00016C3.56715 2.00009 2.56498 2.675 2.09175 3.6535L7.36197 3.65378C6.88885 2.67523 5.88674 2.00022 4.72695 2.00016V2.00016Z"
          fill="#FF9811"
        />
        <path
          d="M4.72664 7.85094C5.88644 7.851 6.88861 7.1761 7.36185 6.1976L2.09161 6.19732C2.56474 7.17587 3.56684 7.85088 4.72664 7.85094Z"
          fill="#6DA544"
        />
        <path
          d="M4.72674 5.94307C5.2887 5.9431 5.74429 5.48757 5.74432 4.92561C5.74435 4.36364 5.28881 3.90806 4.72685 3.90803C4.16489 3.908 3.7093 4.36353 3.70927 4.9255C3.70924 5.48746 4.16478 5.94304 4.72674 5.94307Z"
          fill="#0052B4"
        />
        <path
          d="M4.72677 5.5615C5.07799 5.56152 5.36273 5.27681 5.36275 4.92558C5.36277 4.57436 5.07806 4.28961 4.72683 4.2896C4.37561 4.28958 4.09087 4.57429 4.09085 4.92552C4.09083 5.27674 4.37554 5.56148 4.72677 5.5615Z"
          fill="#F0F0F0"
        />
        <path
          d="M4.72684 4.14079L4.92302 4.58576L5.40644 4.53321L5.11918 4.92557L5.4064 5.31797L4.92298 5.26536L4.72676 5.71031L4.53059 5.26534L4.04716 5.31788L4.33442 4.92553L4.04721 4.53313L4.53062 4.58574L4.72684 4.14079Z"
          fill="#0052B4"
        />
      </g>
      <rect
        x="1.28308"
        y="1.48146"
        width="6.88781"
        height="6.88781"
        rx="3.4439"
        stroke="#CAECD1"
        strokeWidth="1.03702"
      />
      <defs>
        <clipPath id="clip0_141_423">
          <rect
            x="1.80156"
            y="2"
            width="5.85079"
            height="5.85079"
            rx="2.92539"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NationUs: FC = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="nation"
    >
      <g clipPath="url(#clip0_141_428)">
        <path
          d="M4.96203 7.64501C6.73927 7.64494 8.17995 6.20414 8.17987 4.4269C8.1798 2.64966 6.739 1.20898 4.96176 1.20905C3.18452 1.20913 1.74384 2.64992 1.74391 4.42716C1.74399 6.20441 3.18479 7.64508 4.96203 7.64501Z"
          fill="#F0F0F0"
        />
        <path
          d="M4.822 4.42704L8.17988 4.4269C8.17987 4.13645 8.14114 3.85508 8.06899 3.58743L4.82196 3.58756L4.822 4.42704Z"
          fill="#D80027"
        />
        <path
          d="M4.82192 2.74809L7.70749 2.74798C7.51049 2.42654 7.25861 2.14242 6.96493 1.90853L4.82188 1.90862L4.82192 2.74809Z"
          fill="#D80027"
        />
        <path
          d="M4.96203 7.64501C5.71938 7.64498 6.41547 7.38319 6.96515 6.94537L2.95886 6.94554C3.50858 7.38331 4.20469 7.64504 4.96203 7.64501Z"
          fill="#D80027"
        />
        <path
          d="M2.2163 6.10609L7.70763 6.10586C7.86576 5.8478 7.9884 5.56572 8.06905 5.26637L1.8548 5.26662C1.93548 5.56597 2.05814 5.84804 2.2163 6.10609V6.10609Z"
          fill="#D80027"
        />
        <path
          d="M3.23443 1.71166L3.52768 1.71164L3.25492 1.90982L3.35912 2.23047L3.08635 2.03232L2.8136 2.2305L2.90359 1.95348C2.66343 2.15355 2.45294 2.38794 2.27948 2.64911L2.37345 2.6491L2.19982 2.77525C2.17277 2.82038 2.14683 2.86623 2.12196 2.91275L2.20489 3.16793L2.05019 3.05555C2.01175 3.13702 1.97658 3.22032 1.94497 3.30536L2.03633 3.58653L2.37349 3.58652L2.10072 3.7847L2.20493 4.10535L1.93216 3.90719L1.76877 4.02591C1.75243 4.15737 1.74391 4.29127 1.74391 4.42716L4.96189 4.42703C4.96182 2.6498 4.96181 2.44028 4.96176 1.20905C4.32606 1.20908 3.73347 1.39351 3.23443 1.71166V1.71166ZM3.3592 4.1053L3.08643 3.90714L2.81368 4.10532L2.91786 3.78466L2.64508 3.58651L2.98224 3.58649L3.08641 3.26583L3.1906 3.58648L3.52776 3.58647L3.25499 3.78465L3.3592 4.1053ZM3.25495 2.84724L3.35916 3.16789L3.08639 2.96973L2.81364 3.16791L2.91782 2.84725L2.64504 2.64909L2.9822 2.64908L3.08637 2.32842L3.19056 2.64907L3.52772 2.64906L3.25495 2.84724ZM4.51348 4.10525L4.24071 3.90709L3.96795 4.10527L4.07213 3.78462L3.79935 3.58646L4.13651 3.58644L4.24068 3.26579L4.34487 3.58644L4.68203 3.58642L4.40927 3.7846L4.51348 4.10525ZM4.40923 2.84719L4.51344 3.16784L4.24067 2.96968L3.96791 3.16786L4.0721 2.8472L3.79931 2.64905L4.13647 2.64903L4.24064 2.32837L4.34484 2.64902L4.68199 2.64901L4.40923 2.84719ZM4.40919 1.90978L4.5134 2.23043L4.24063 2.03227L3.96788 2.23045L4.07206 1.90979L3.79927 1.71163L4.13643 1.71162L4.2406 1.39096L4.3448 1.71161L4.68196 1.7116L4.40919 1.90978Z"
          fill="#0052B4"
        />
      </g>
      <rect
        x="1.22525"
        y="0.690695"
        width="7.47298"
        height="7.47298"
        rx="3.73649"
        stroke="#0077FF"
        strokeOpacity="0.2"
        strokeWidth="1.03702"
      />
      <defs>
        <clipPath id="clip0_141_428">
          <rect
            x="1.74378"
            y="1.20918"
            width="6.43596"
            height="6.43596"
            rx="3.21798"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NationVn: FC = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="nation"
    >
      <g clipPath="url(#clip0_141_431)">
        <path
          d="M4.35507 7.44949C6.06406 7.44949 7.44948 6.06407 7.44948 4.35508C7.44948 2.64609 6.06406 1.26067 4.35507 1.26067C2.64608 1.26067 1.26067 2.64609 1.26067 4.35508C1.26067 6.06407 2.64608 7.44949 4.35507 7.44949Z"
          fill="#D80027"
        />
        <path
          d="M4.35507 2.87514L4.68903 3.90293H5.76971L4.89541 4.53813L5.22936 5.56594L4.35507 4.93072L3.48078 5.56594L3.81474 4.53813L2.94044 3.90293H4.02112L4.35507 2.87514Z"
          fill="#FFDA44"
        />
      </g>
      <rect
        x="0.742155"
        y="0.742163"
        width="7.22583"
        height="7.22583"
        rx="3.61292"
        stroke="#FD4103"
        strokeOpacity="0.16"
        strokeWidth="1.03702"
      />
      <defs>
        <clipPath id="clip0_141_431">
          <rect
            x="1.26067"
            y="1.26067"
            width="6.18881"
            height="6.18881"
            rx="3.09441"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
